jQuery(document).ready($ => {
	if($('#adaptation-champions-switcher').length) {

		$('.additional-adaptation-champion').click(e => {
			const champion_id = $(e.target).data('championId');
			switchAdaptationChampion(champion_id);
		})
	}

	function switchAdaptationChampion(champion_id) {
		$('.adaptation-champion-info').hide();
		$('.adaptation-champion-info[data-champion-id="'+champion_id+'"]').show();
	}
})